import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classNames from 'classnames';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import MediaPickerModal from '../MediaPicker/MediaPickerModal';
import Input from '../Input';
const DEFAULT_UPLOAD_PATH = 'widget-designer/images/';
/**
 * @export
 * Image browse dialog: keyword search of the platform image library
 * (Unsplash, proxied by the Lucy `SearchImagesFromUnsplash` service) plus
 * user uploads and the caller's media library.
 *
 * An image-only MediaPickerModal.
 *
 * @partOf ImagePicker
 */
export const ImagePickerModal = (props) => {
    const { show, onClose, onSelect, uploadPath, searchParameters, sources, allowedTypes, defaultSource } = props;
    return _jsx(MediaPickerModal, { show: show, onClose: onClose, onSelect: onSelect, mediaTypes: ['Image'], sources: sources, allowedTypes: allowedTypes, defaultSource: defaultSource !== null && defaultSource !== void 0 ? defaultSource : 'gallery', uploadPath: uploadPath !== null && uploadPath !== void 0 ? uploadPath : DEFAULT_UPLOAD_PATH, searchParameters: searchParameters });
};
/**
 * @export
 * An image URL input with a browse suffix — opens the image browser
 * (search the image library or upload your own).
 *
 * @example
 * ```tsx
 * <ImagePicker
 *     value={imageUrl}
 *     onChange={url => setImageUrl(url)}
 * />
 * ```
 *
 * @category Inputs/Pickers/Image
 */
export const ImagePicker = (props) => {
    const { value, onChange, placeholder, className, disabled, uploadPath, searchParameters, sources, allowedTypes, defaultSource } = props;
    const [browsing, setBrowsing] = React.useState(false);
    return _jsxs("div", { className: classNames('uxpcore_imagepicker', className), children: [_jsx(Input, { value: value || '', onChange: (v) => onChange(v), placeholder: placeholder || 'Image URL', disabled: disabled, suffix: {
                    value: _jsx("span", { className: "uxpcore_imagepicker__browse", onClick: () => { if (!disabled)
                            setBrowsing(true); }, children: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'images'] }) }),
                    showSeparator: true,
                } }), _jsx(ImagePickerModal, { show: browsing, onClose: () => setBrowsing(false), onSelect: onChange, uploadPath: uploadPath, searchParameters: searchParameters, sources: sources, allowedTypes: allowedTypes, defaultSource: defaultSource })] });
};
export default ImagePicker;
